(() => {
  if (window.__lotusOrderPolicyInstalled) return;
  window.__lotusOrderPolicyInstalled = true;

  function renderPolicies() {
    document.querySelectorAll('[data-lotus-policy]').forEach((notice) => {
      const policy = notice.querySelector('[data-lotus-overstock-notice]');
      if (!policy) return;

      let flagged = [];
      try {
        flagged = JSON.parse(notice.querySelector('[data-lotus-overstock-skus]')?.textContent || '[]');
      } catch (_) {
        policy.hidden = true;
        return;
      }
      // Shopify's product.variants is limited to 250 entries. The full
      // metafield is not; compare the exact selected variant SKU instead.
      const section = notice.closest('product-info');
      const idInput = section?.querySelector('form[id="product-form-' + notice.dataset.policySection + '"] input[name="id"]');
      const formVariantId = idInput?.value || '';
      const expectedId = notice.dataset.selectedVariantId || '';
      const sku = notice.dataset.selectedSku || '';
      // Do not show a warning for an invalid or in-flight selection.
      const selected = !idInput || (formVariantId && formVariantId === expectedId);
      policy.hidden = !(selected && sku && flagged.includes(sku));
    });
  }

  let scheduled = false;
  function queueUpdate() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      renderPolicies();
    });
  }

  // Dawn's product-info.js publishes the exact selected variant returned by
  // the Ajax section response, including high-variant products.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const data = event?.data;
      if (!data) return;
      document.querySelectorAll('[data-lotus-policy]').forEach((notice) => {
        const root = notice.closest('product-info');
        if (!root || (root.dataset.originalSection || root.dataset.section) !== String(data.sectionId)) return;
        notice.dataset.selectedVariantId = data.variant?.id ? String(data.variant.id) : '';
        notice.dataset.selectedSku = data.variant?.sku || '';
      });
      queueUpdate();
    });
  }

  document.addEventListener('change', queueUpdate, true);
  document.addEventListener('input', queueUpdate, true);
  window.addEventListener('popstate', queueUpdate);
  document.addEventListener('DOMContentLoaded', queueUpdate);
  const observer = new MutationObserver((changes) => {
    if (changes.some((change) => change.addedNodes.length || change.removedNodes.length)) queueUpdate();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  queueUpdate();
})();
